import { createContext, useContext, useMemo } from 'react';

const JWT_TOKEN_SESSION_KEY = 'signed_payload_jwt';
const ClientContext = createContext(async () => {});

function createClient(base, token, endpoints) {
	const defaultHeaders = {
		'Content-Type': 'application/json',
		...(token ? { token } : {}),
	};

	return Object.assign(
		(url, options = {}) =>
			fetch(new URL(url, base).toString(), {
				...options,
				headers: {
					...defaultHeaders,
					...(options.headers || {}),
				},
			}),
		{
			base,
			headers: {
				...defaultHeaders,
			},
		},
		endpoints,
	);
}

function ClientProvider({ children, endpoints }) {
	const client = useMemo(() => {
		let token = sessionStorage.getItem(JWT_TOKEN_SESSION_KEY);

		// Check if we have a token in the url, if so, update our session with it
		const params = new URLSearchParams(window.location.search);
		const paramToken = params.get(JWT_TOKEN_SESSION_KEY);

		if (paramToken) {
			token = paramToken;
			sessionStorage.setItem(JWT_TOKEN_SESSION_KEY, paramToken);
		}

		return createClient(
			process.env.REACT_APP_MIDDLEWARE_URL,
			token,
			endpoints,
		);
	}, [endpoints]);

	return (
		<ClientContext.Provider value={client}>
			{children}
		</ClientContext.Provider>
	);
}

/**
 * @returns {import('../middleware.js')}
 */
const useClient = () => useContext(ClientContext);

export { JWT_TOKEN_SESSION_KEY, ClientProvider, useClient };
